import { render, staticRenderFns } from "./GarageRecommendation.vue?vue&type=template&id=01d77012&scoped=true"
import script from "./GarageRecommendation.vue?vue&type=script&lang=js"
export * from "./GarageRecommendation.vue?vue&type=script&lang=js"
import style0 from "./GarageRecommendation.vue?vue&type=style&index=0&id=01d77012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d77012",
  null
  
)

export default component.exports